import styled from '@emotion/styled'

import { Color, theme } from '../../constants'
import { Div } from '../../elements'

export const AvailabilityRowBase = styled(Div)<{ gridTemplateColumns: string }>`
  display: grid;
  gap: ${theme.spacing[3]}px;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns};
  align-items: center;
  margin: 0;
  min-height: 48px;
  padding-left: ${theme.spacing[3]}px;
`
export const AvailabilityRowStyles = styled(AvailabilityRowBase)<{
  disabled?: boolean
}>`
  border-top: ${theme.border.style.thinLight};
  ${({ disabled }) =>
    disabled &&
    `
    background-color: ${Color.LIGHT_GREY};
    color: ${Color.DARK_MEDIUM_GREY};
  `}
`

export const GridRowHeaderStyles = styled(AvailabilityRowBase)({
  backgroundColor: Color.BACKGROUND_GREY,
})
